import type { PostApiV1ThreeLetterCodeClientAdminsUsersBody } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import type { CreateUserFormValues } from '../schema';

type Args = {
  formValues: CreateUserFormValues;
};

/**
 * フォームの値から POST リクエストボディを生成する
 */
export const generatePostRequestBody = ({
  formValues,
}: Args): PostApiV1ThreeLetterCodeClientAdminsUsersBody => ({
  user: {
    full_name: formValues.fullName,
    email: formValues.email,
    // branchId が空文字の場合は branch_id を送信しない（spread で省略）
    ...(formValues.branchId ? { branch_id: Number(formValues.branchId) } : {}),
    billable_from: formatDate({ date: formValues.billableFrom, formatType: 'yyyy-MM-dd' }),
  } as PostApiV1ThreeLetterCodeClientAdminsUsersBody['user'],
});
